<template>
  <v-dialog v-model="showModal" width="500px" content-class="message-modal">
    <v-card>
      <v-card-title primary-title>
        <h3 class="headline mb-0">{{ $t('expire_token.title') }}</h3>
      </v-card-title>
      <v-card-text>{{ $t('expire_token.des') }}</v-card-text>
      <v-card-actions class="mr-3 pr-0 pb-3">
        <v-spacer></v-spacer>
        <v-btn dark @click="closeModal">{{ $t('expire_token.confirm') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      showModal: true
    }
  },
  methods: {
    closeModal() {
      this.$store.dispatch('setShowTokenExpireModal', false)
      this.$store.dispatch('setSigninFallback', {
        path: this.$route.path,
        query: this.$route.query
      })
      this.$router.push({ name: 'sign-in', query: this.$route.query })
    }
  },
  watch: {
    showModal(newVal, oldVal) {
      if (newVal !== oldVal && !newVal) {
        this.closeModal()
      }
    }
  }
}
</script>

<style lang="scss"></style>
